let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("a0E5q")).then(() => parcelRequire('4zl0K'));